import { heroQuickTags, heroStats } from "@/mocks/homeData";

const heroImg =
  "https://readdy.ai/api/search-image?query=large%20editorial%20investigative%20collage%2C%20abstract%20faceless%20silhouette%20of%20a%20crowd%20under%20a%20spotlight%2C%20floating%20search%20magnifier%20and%20document%20fragments%2C%20vermilion%20and%20charcoal%20ink%20tones%20with%20warm%20amber%20highlights%2C%20dramatic%20cinematic%20rim%20light%2C%20fine%20paper%20grain%20texture%2C%20high%20contrast%20editorial%20newsroom%20atmosphere&width=1920&height=960&seq=hero-main-01&orientation=landscape";

export default function Hero() {
  return (
    <section id="top" className="relative flex min-h-[680px] flex-col overflow-hidden">
      <div className="absolute inset-0">
        <img src={heroImg} alt="网曝人物热点追踪背景图" className="h-full w-full object-cover object-top" />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/80 via-background-950/55 to-background-50" />
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/40 to-transparent" />
      </div>

      <div className="relative z-10 mx-auto flex w-full max-w-6xl flex-1 flex-col items-center justify-center px-4 pb-10 pt-28 text-center md:px-6 md:pt-32">
        <span className="inline-flex items-center gap-2 rounded-full bg-accent-500 px-4 py-1.5 text-xs font-medium text-foreground-950">
          <span className="h-1.5 w-1.5 rounded-full bg-foreground-950 animate-pulse-dot" />
          人物热点信息追踪 · 公开信息整理
        </span>

        <h1 className="mt-6 max-w-4xl font-heading text-3xl font-bold leading-tight text-background-50 sm:text-4xl md:text-5xl">
          一个热曝突然刷屏，
          <br className="md:hidden" />
          <span className="mx-1 text-accent-300">当事人是谁</span>
          你真的搞清了吗？
        </h1>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-100/90 md:text-lg">
          从网曝身份起底到网曝背景深扒，再到网曝关联人物与网曝旧料翻出——
          我们把散落各处的公开线索按可查证程度串成一张完整画像，帮你少走弯路、少被带节奏。
        </p>

        <div className="mt-8 flex w-full max-w-2xl items-center gap-1 rounded-lg bg-background-50 p-1.5 shadow-none ring-1 ring-background-50/30">
          <i className="ri-search-line px-2 text-lg text-secondary-500" />
          <input
            type="text"
            placeholder="搜事件、当事人或话题标签…"
            className="w-full bg-transparent py-2 text-sm text-foreground-900 outline-none placeholder:text-secondary-500"
          />
          <button
            type="button"
            className="inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
          >
            开始追踪
            <i className="ri-arrow-right-s-line" />
          </button>
        </div>

        <div className="mt-4 flex flex-wrap items-center justify-center gap-2">
          {heroQuickTags.map((tag) => (
            <span
              key={tag}
              className="inline-flex items-center gap-1.5 rounded-full bg-background-50/10 px-3 py-1 text-xs text-background-50 ring-1 ring-background-50/20 transition-colors hover:bg-background-50/20"
            >
              <i className="ri-price-tag-3-line text-accent-300" />
              {tag}
            </span>
          ))}
        </div>
      </div>

      <div className="relative z-10 mx-auto w-full max-w-6xl px-4 pb-6 md:px-6">
        <div className="grid grid-cols-2 gap-3 rounded-lg border border-background-200/70 bg-background-50/90 p-4 backdrop-blur sm:grid-cols-4 sm:gap-4 md:p-5">
          {heroStats.map((stat) => (
            <div key={stat.label} className="text-left">
              <p className="font-heading text-2xl font-bold text-primary-600 md:text-3xl">{stat.value}</p>
              <p className="mt-1 text-xs text-foreground-600 md:text-sm">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}